import api from "./Api";

class SubGrupoService {
  GetSubGrupo(payload) {
    return api.get("/v1/subGrupo/" + payload).then((response) => {
      return response.data;
    });
  }

  PostSubGrupo(payload) {
    return api.post("/v1/subGrupo/", payload).then((response) => {
      return response.data;
    });
  }

  PutSubGrupo(payload) {
    return api.put("/v1/subgrupo/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteSubGrupo(payload) {
    return api.delete("/v1/subGrupo/" + payload).then((response) => {
      return response.data;
    });
  }

  GetSubGrupoOData(payload) {
    return api.get("/OData/SubGrupo" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new SubGrupoService();
